<p-dialog styleClass='w-10 lg:w-8 xl:w-6' [header]='headerTxt' [visible]='visible'
          (visibleChange)='onVisibleChange($event)'>
  @if (visible) {
    <ngx-extended-pdf-viewer backgroundColor='#ffffff' pageViewMode='infinite-scroll' zoom='page-width' [src]='pdfSrc'>
    </ngx-extended-pdf-viewer>
  }
</p-dialog>
